import axios from './http'

export function init(token) {
  return axios({
    url: '/api/sale-storage/init',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function selectBrandConfig(token, id) {
  return axios({
    url: '/api/sale-storage/brandConfig/' + id,
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function queryPropValues(token, id, value) {
  return axios({
    url: `/api/sale-storage/queryPropValues?id=${id}&value=${value}`,
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function brandConfigEdit(token, data) {
  return axios({
    url: '/api/sale-storage/brandConfigEdit',
    method: 'put',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

export function downloadDataTemplate(token, parentBrand) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/downloadDataTemplate/' + parentBrand,
    responseType: 'blob',
    headers: {
      'authorization': token
    }
  })
}

export function uploadDataTemplate(token, parentBrand, data) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/uploadDataTemplate/' + parentBrand,
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

export function downloadPropTemplate(parentBrand, token) {
  return axios({
    method: 'get',
    url: '/api/sale-storage/downloadPropTemplate/' + parentBrand,
    responseType: 'blob',
    headers: {
      'authorization': token
    }
  })
}

export function uploadPropTemplate(token, data, brand) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/uploadPropTemplate/' + brand,
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

export function downloadStockTemplate(parentBrand, token) {
  return axios({
    method: 'get',
    url: '/api/sale-storage/downloadStockTemplate/' + parentBrand,
    responseType: 'blob',
    headers: {
      'authorization': token
    }
  })
}

export function downloadOfmomTemplate(type, token) {
  return axios({
    method: 'get',
    url: '/api/sale-storage/downloadOfmomTemplate/' + type,
    headers: {
      'authorization': token
    }
  })
}

export function uploadOfmomStockTemplate(token, data, type) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/uploadOfmomStockTemplate/' + type,
    headers: {
      'authorization': token,
      // 'Content-Type':'multipart/form-data'
    },
    data: data
  })
}

export function uploadStockTemplate(token, data, brand, stockSupplier) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/uploadStockTemplate/' + brand + "/" + stockSupplier,
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

export function downStock(token, data) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/downloadStockData',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function downloadSaleReport(token, data) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/downloadSaleReport',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function querySaleReport(token, data) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/querySaleReport',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function downloadOfmomData(token, data) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/downloadOfmomData',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function queryUploadRecord(token, data) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/queryUploadRecord',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function uploadSupplierPropValue(token, data, parentBrandId) {
  return axios({
    method: 'post',
    url: '/api/sale-storage/uploadSupplierPropValue/' + parentBrandId,
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

export function downloadSupplierPropValue(token,parentBrandId) {
  return axios({
    method: 'get',
    url: '/api/sale-storage/downloadSupplierPropValue?parentBrandId=' + parentBrandId,
    responseType: 'blob',
    headers: {
      'authorization': token
    }
  })
}
